<!--选择时间-->
<template>
  <div
    :class="{
      'select-time': true,
    }"
    @click.stop="timeClick"
  >
    <el-date-picker
      v-model="time"
      type="month"
      align="center"
      :picker-options="pickerOptions"
      :editable="editableBool"
      @change="changeTime"
      @blur="toggleTimeShow(false)"
      @focus="toggleTimeShow(true)"
      :disabled="!is_login||!is_member"
    ></el-date-picker>
    <div class="cover-picker" v-if="!is_login||!is_member"></div>
    <!-- <div
      class="input-value"
      v-if="isSafari || isIE || isEdge"
    >{{ time }}</div> -->
    <!-- <img
      :class="{'time-row-ani':timeShow}"
      class="time-row"
      src="@/assets/image/layout/row-down.svg"
      alt="down"
    /> -->
  </div>
</template>

<script>
let date = new Date()
import { mapState } from 'vuex'
import { isSafari, isFirefox, isIE, isEdge } from '@/utils/globalFunction'

export default {
  name: 'SelectTime',
  data() {
    return {
      editableBool: false, // 输入框是否允许自由输入
      timeShow: false,
      time: this.$store.state.time,
      oldTIme:JSON.parse(JSON.stringify(this.$store.state.realTime)),
      pickerOptions: {
        disabledDate: time => {
          // let startMonth = 24243 //2020年6月
          // let newmonth = time.getFullYear() * 12 + time.getMonth()
          // let date = new Date()
          // let day = date.getDate()
          // let end = ''
          // let start = ''
          // if (day < 15) {
          //   //每个月三号才能刷新上个月数据
          //   end = date.getFullYear() * 12 + date.getMonth() - 2
          //   start = date.getFullYear() * 12 + date.getMonth() - 4
          // } else {
          //   end = date.getFullYear() * 12 + date.getMonth() - 1
          //   start = date.getFullYear() * 12 + date.getMonth() - 3
          // }
          let newmonth = time.getFullYear() * 12 + time.getMonth()
          let end = ''
          let start = ''
          let time1 = parseInt(this.oldTIme.split('-')[0])
          let time2 = parseInt(this.oldTIme.split('-')[1])
          end = time1 * 12 + time2 - 1
          start = time1 * 12 + time2 - 3
          // if (newmonth < start || newmonth > end) {
          return newmonth < start || newmonth > end;

        }
      },
      isSafari,
      isFirefox,
      isIE,
      isEdge
    }
  },
  methods: {
    /**
     * 修改timeShow状态
     * @param {boolean} bool
     * **/
    toggleTimeShow(bool) {
      this.timeShow = bool
    },
    //点击时间选择器
    timeClick() {
      if (!this.is_login) {
        this.$loginDialog.open()
      }
      if(this.is_login&&!this.is_member) {
        this.$msgBox
          .showMsgBox({
            content: '开通测速网大数据会员，可查看近3个月平台页面展示的所有数据',
            cancelVal: '我再想想',
            confirmVal: '立即开通'
          })
          .then(async val => {
            // ...
            this.$router.push({ path: '/pay-member' })
          })
          .catch(() => {
            // ...
            console.log('取消')
          })
      }
    },

    /**
     * 修改时间
     * */
    changeTime(e) {
      this.time = `${e.getFullYear()}-${e.getMonth() + 1}`
      this.$store.dispatch('changeTime', `${e.getFullYear()}-${e.getMonth() + 1}`)
      let num = new Date().getMonth() - e.getMonth()
      if (num < 0) {
        num = 12 + num
      }
      this.$store.dispatch('changeMonth', String(num))
    }
  },
  computed: {
    ...mapState('login', ['is_login','is_member'])
  }
}
</script>

<style scoped lang="less">
.select-time {
  width: 1.73rem;
  font-size: 0.12rem;
  position: relative;
  margin-right: 0.1rem;
  .cover-picker {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  :deep(input.el-input__inner) {
    cursor: pointer;
  }
}

.time-row-ani {
  transform: rotate(180deg);
}

.time-row {
  position: absolute;
  left: 1.2rem;
  top: 0.12rem;
  pointer-events: none;
}
.input-value {
  font-size: 0.16rem;
  display: flex;
  padding: 0.15rem 0 0 0.16rem;
  font-weight: 500;
  color: #82ebff;
  position: absolute;
  left: 0;
  top: 0;
}
::v-deep(.el-input.is-disabled .el-input__inner) {
  background-color: transparent;
  color: #82ebff;
  //cursor: not-allowed;
}
::v-deep(.el-input__inner) {
  font-family: "Noto Sans SC" !important;
}
</style>
